
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface StorageConditionsFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const StorageConditionsField = ({ value, onChange }: StorageConditionsFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="storageConditions">Storage Conditions</Label>
      <Input
        id="storageConditions"
        name="storageConditions"
        value={value}
        onChange={onChange}
        placeholder="e.g., Room temperature, 4°C, -20°C"
      />
    </div>
  );
};

export default StorageConditionsField;
